import { Directive, ElementRef, Renderer2, ViewContainerRef, AfterViewInit, ComponentRef } from '@angular/core';
import { ShowPasswordButtonComponent } from './show-password-button/show-password-button.component';

@Directive({
	selector: '[goPasswordVisibilityToggle]',
	standalone: false
})
export class PasswordVisibilityToggleDirective implements AfterViewInit {
	private passwordInput: HTMLInputElement | null = null;
	private passwordHidden = true;
	private componentRef: ComponentRef<ShowPasswordButtonComponent>;

	constructor (
		private el: ElementRef,
		private renderer: Renderer2,
		private viewContainerRef: ViewContainerRef
	) {}

	public ngAfterViewInit () {
		// Find the password input
		this.passwordInput = this.el.nativeElement.querySelector('input[type="password"]');

		if (this.passwordInput) {
			// Create and append the ShowPasswordButtonComponent
			this.createAndAppendToggleButton();
		}
	}

	private createAndAppendToggleButton () {
		this.componentRef = this.viewContainerRef.createComponent(ShowPasswordButtonComponent);

		// Set initial state and bind to onClick event
		this.componentRef.instance.passwordHidden = this.passwordHidden;
		this.componentRef.instance.onClick.subscribe(() => this.togglePasswordVisibility());

		const matFormFieldSuffix = this.el.nativeElement.querySelector('.mat-mdc-form-field-icon-suffix');
		if (!matFormFieldSuffix) {
			const div = this.renderer.createElement('div');
			this.renderer.addClass(div, 'mat-mdc-form-field-icon-suffix');

			this.renderer.appendChild(
				this.el.nativeElement.querySelector('.mat-mdc-form-field-flex'),
				div
			);

			this.renderer.appendChild(
				div,
				this.componentRef.location.nativeElement
			);
		} else {
			this.renderer.insertBefore(
				matFormFieldSuffix,
				this.componentRef.location.nativeElement,
				matFormFieldSuffix.firstElementChild
			);
		}

		this.componentRef.changeDetectorRef.detectChanges();
	}

	private togglePasswordVisibility () {
		if (this.passwordInput) {
			this.passwordHidden = !this.passwordHidden;
			const type = this.passwordHidden ? 'password' : 'text';
			this.renderer.setAttribute(this.passwordInput, 'type', type);
			this.componentRef.instance.passwordHidden = this.passwordHidden;
		}
	}
}
